import {Injectable} from '@angular/core';
import { environment } from '../../environments/environment';
import {Observable} from 'rxjs';
import {CustomHttpResponse} from '../model/custom-http-response';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { CACHE_ENABLED } from '../interceptor/cache.interceptor';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  host = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getAllCategory(): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(
      `${this.host}/v1/public/categories`,
      {
        observe: 'response',
        context: new HttpContext().set(CACHE_ENABLED, true)
      }
    )
  }

}
